/**
 * Formats the telephone number as +X XXX XXX XXXX
 */
const formatTel = (s: string): string => `${s.slice(0, 2)} ${s.slice(2, 5)} ${s.slice(5, 8)} ${s.slice(8, 12)}`;
export default formatTel;
